<template>
    <main data-type="top-level-container" class="main-area">
        <div id="status" />
        <slot name="header" />
        <nuxt-page />
        <template
            v-for="(item, index) in customModals"
            :key="index"    
        >
            <component
                :is="item.component"
                v-if="item.isShown"
                :title="item.title"
                :message="item.message"
                :buttons="item.buttons"
                :name="item.name"
                :api-message="item.apiMessage"
                :loading="item.loading"
                :focused-ind="item.focusedInd"
                @on-btn-click="item.clickHandler"
                @close="item.closeHandler"
            />
        </template>
        <template
            v-for="(item, index) in defaultModals"
            :key="index"    
        >
            <component
                :is="item.component"
                v-if="item.isShown"
                @on-btn-click="item.clickHandler"
                @close="item.closeHandler"
            />
        </template>
        <Page-Loading-Indicator v-show="getIsLoadingPageIndicator"/>
    </main>
</template>

<script setup lang="ts">
    import { useOnline } from '@vueuse/core';
    import { useGlobalModals } from "@/composables/globalModals/useGlobalModals";
    import { useApplicationStore } from "@/stores/Application";
    import { storeToRefs } from 'pinia';
    
    const ApplicationStore = useApplicationStore();
    const { getIsLoadingPageIndicator } = storeToRefs(ApplicationStore);
    const { 
        showInternetModal,
    } = ApplicationStore;

    const { customModals, defaultModals } = useGlobalModals();

    const isOffline = computed((): boolean => !useOnline().value);
    watch(
        isOffline,
        (value: boolean): void => {
            showInternetModal(value);
        }
    );
</script>
